import React from 'react';
import FollowupActions from './FollowupActions';

/**
 * Visas när kunden inte har begärt någon uppföljning
 * Scenario D: NO_REQUEST
 */
const NoMeetingRequest = ({ onSuggestTime, onBookMeeting, onApproveForCustomer, onBookHomeVisit, approveLoading, isApproved = false }) => {
  return (
    <div>
      <div className="text-sm text-gray-700 mb-4">
        Kunden har inte begärt någon uppföljning, men du kan föreslå tider, boka ett möte direkt, eller godkänna estimatet åt kund.
      </div>
      <FollowupActions
        onSuggestTime={onSuggestTime}
        onBookMeeting={onBookMeeting}
        onApproveForCustomer={onApproveForCustomer}
        onBookHomeVisit={onBookHomeVisit}
        approveLoading={approveLoading}
        isApproved={isApproved}
      />
    </div>
  );
};

export default NoMeetingRequest;
